var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTable = function SvgIconTable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 4.25a1 1 0 0 0-1 1V18a1.75 1.75 0 0 0 1.75 1.75h16.5A1.75 1.75 0 0 0 22 18V5.25a1 1 0 0 0-1-1zm6.25 13.5H20v-2.5H9.25zm-2-2.5v2.5H4v-2.5zm2-2H20v-2.5H9.25zm-2-2.5v2.5H4v-2.5zm12.75-2v-2.5H4v2.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTable;